import Slider, { Settings } from 'react-slick'
import DemosFeaturedCard from '../DemosFeaturedCard/DemosFeaturedCard'
import { graphql, useStaticQuery } from 'gatsby'
import './DemosFeaturedCarousel.scss'

interface IDemosFeaturedCarouselProps {
  title: string
  className?: string
}

const DemosFeaturedCarousel = ({
  title,
  className = '',
}: IDemosFeaturedCarouselProps) => {
  const slickSettings: Settings = {
    dots: false,
    infinite: true,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    accessibility: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          className: 'center',
          centerMode: true,
          centerPadding: '200px',
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerMode: false,
        },
      },
    ],
  }

  const { pennylaneCloud }: Queries.FeaturedDemosQuery =
    useStaticQuery<Queries.FeaturedDemosQuery>(demosFeaturedQuery)
  const demos = pennylaneCloud.featuredDemos

  const carouselDemos = demos.map((demo) => (
    <div key={demo.slug} className="DemosFeaturedCarousel__card">
      <DemosFeaturedCard
        slug={demo.slug}
        image={demo.thumbnailLarge}
        title={demo.title}
        categories={demo.categories.map((cat) => cat.title)}
      />
    </div>
  ))

  return carouselDemos.length ? (
    <section className={`DemosFeaturedCarousel ${className}`}>
      <h2 className="DemosFeaturedCarousel__title">{title}</h2>
      <div className="my-10">
        <Slider {...slickSettings}>{carouselDemos}</Slider>
      </div>
    </section>
  ) : null
}

export default DemosFeaturedCarousel

export const demosFeaturedQuery = graphql`
  query FeaturedDemos {
    pennylaneCloud {
      featuredDemos {
        thumbnailLarge
        title
        slug
        categories {
          title
        }
      }
    }
  }
`
